// extracted by mini-css-extract-plugin
export var sliderRange = "_cb-2";
export var sliderRoot = "_cb-0";
export var sliderThumb = "_cb-3";
export var sliderTrack = "_cb-1";